// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d690a5e2","845":"f01e244b"}[chunkId] + ".chunk.js";
};